import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getPartners = () => axios.get(`${API}/partners`).then((r) => r.data);
export const sendContact = (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data);

const authHeader = (token) => ({ headers: { "X-Admin-Token": token } });
export const verifyAdmin = (token) => axios.post(`${API}/admin/verify`, {}, authHeader(token)).then((r) => r.data);
export const getContacts = (token) => axios.get(`${API}/contacts`, authHeader(token)).then((r) => r.data);
export const createPartner = (payload, token) => axios.post(`${API}/partners`, payload, authHeader(token)).then((r) => r.data);
export const deletePartner = (id, token) => axios.delete(`${API}/partners/${id}`, authHeader(token)).then((r) => r.data);
export const getSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const updateSettings = (payload, token) => axios.put(`${API}/settings`, payload, authHeader(token)).then((r) => r.data);
export const getHotels = () => axios.get(`${API}/hotels`).then((r) => r.data);
export const createHotel = (payload, token) => axios.post(`${API}/hotels`, payload, authHeader(token)).then((r) => r.data);
export const deleteHotel = (id, token) => axios.delete(`${API}/hotels/${id}`, authHeader(token)).then((r) => r.data);

export const galleryImageUrl = (id) => `${API}/gallery/image/${id}`;
export const getGallery = () => axios.get(`${API}/gallery`).then((r) => r.data);
export const uploadGalleryImage = (formData, token) =>
  axios.post(`${API}/gallery`, formData, { headers: { "X-Admin-Token": token, "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const deleteGalleryImage = (id, token) => axios.delete(`${API}/gallery/${id}`, authHeader(token)).then((r) => r.data);
export const reorderGallery = (ids, token) => axios.put(`${API}/gallery/reorder`, { ids }, authHeader(token)).then((r) => r.data);

export const getTestimonials = () => axios.get(`${API}/testimonials`).then((r) => r.data);
export const getTestimonialsSummary = () => axios.get(`${API}/testimonials/summary`).then((r) => r.data);
export const getTestimonialsAdmin = (token) => axios.get(`${API}/testimonials/admin`, authHeader(token)).then((r) => r.data);
export const createTestimonial = (payload) => axios.post(`${API}/testimonials`, payload).then((r) => r.data);
export const approveTestimonial = (id, token) => axios.put(`${API}/testimonials/${id}/approve`, {}, authHeader(token)).then((r) => r.data);
export const deleteTestimonial = (id, token) => axios.delete(`${API}/testimonials/${id}`, authHeader(token)).then((r) => r.data);
